import { useUserProductsPos } from "~/api/products/hooks/use-user-products";
import {
  useEmployee,
  useIsEmployeeAuthenticated
} from "~/providers/store/employee";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { useBasketContext } from "~/providers/store/basket/context";

import { BasketHeaderAuth } from "./basket-header-auth";
import { BasketHeaderGuest } from "./basket-header-guest";

export const BasketHeader = () => {
  const employeeData = useEmployee();
  const isUserAuthenticated = useIsEmployeeAuthenticated();
  const { data: userProducts } = useUserProductsPos();

  const { data: showUserBalanceAndDailySpendingLimit } = useCurrentTill(
    (till) => {
      if (till.moduleConfig.paymentMethod !== "credit") {
        return false;
      }

      if (
        till.type === "collect" ||
        till.type === "self-service" ||
        till.type === "attended"
      ) {
        return till.config.showUserBalanceAndDailySpendingLimit;
      }

      return false;
    }
  );
  const { locale, currency, language } = useCurrentTillLocalisation();

  const isEmpty = useBasketContext((state) => state.isBasketEmpty);

  const displayName = userProducts?.user?.name ?? null;
  const balance = userProducts?.user?.balance ?? null;

  const groupName = userProducts?.user?.groupName || employeeData.groupName;

  const allergensCustom = userProducts?.user?.allergensCustom;
  const allergens = [
    ...(userProducts?.user?.allergens ?? []),
    ...(allergensCustom ? [allergensCustom] : [])
  ];

  if (isUserAuthenticated) {
    return (
      <BasketHeaderAuth
        currency={currency}
        locale={locale}
        language={language}
        username={displayName}
        groupName={groupName}
        balance={balance}
        collectLimit={userProducts?.user?.collectLimit ?? null}
        allergens={allergens}
        isEmpty={isEmpty}
        showUserBalanceAndDailySpendingLimit={
          showUserBalanceAndDailySpendingLimit
        }
      />
    );
  }

  return <BasketHeaderGuest isEmpty={isEmpty} />;
};
